import React from 'react';

import MarkerOverlayContent from './MarkerOverlayContent';
import track from '../../../lib/track';
import { NewMarkerIcon } from '../Icons';
import { ListingStatus } from '../../../lib/constants';
import styles from './styles';

interface Props {
  isOverlayShown: boolean;
  lat: any;
  listing: any;
  lng: any;
  markerClicked: string;
  markerFocused: string;
  onMarkerClick: Function;
  onMouseLeaveMarker: Function;
  onMouseOverMarker: Function;
  overlayListing: any;
  selectedListing: any;
  marker: any;
  router: any;
  listings: any;
}

export const ClusterMarker = (props: Props) => {
  const {
    isOverlayShown,
    listing,
    listings,
    marker,
    markerClicked,
    markerFocused,
    onMarkerClick,
    onMouseLeaveMarker,
    onMouseOverMarker,
    overlayListing,
    selectedListing,
    router,
  } = props;
  let markerIndex = 0;
  if (markerClicked === listing.id) {
    markerIndex = 200;
  } else if (listing.status === ListingStatus.New) {
    markerIndex = 99;
  } else if (overlayListing.id === listing.id) {
    markerIndex = 100;
  } else if (markerFocused === listing.id) {
    markerIndex = 100;
  }

  return (
    <div
      onMouseDown={() =>
        track.buttonClick(`Marker: ${listing.id}`, router.pathname, '')
      }
    >
      {isOverlayShown && overlayListing.id === listing.id && (
        <div
          style={{
            ...styles.overlayContainer,
            maxHeight: 230,
            overflowY: 'scroll',
            position: 'absolute',
            top: listings.length >= 3 ? -250 : -175,
            zIndex: 300,
          }}
        >
          <MarkerOverlayContent overlayListings={listings} />
        </div>
      )}
      {markerClicked && selectedListing.id === listing.id && (
        <div
          style={{
            ...styles.overlayContainer,
            maxHeight: 230,
            overflowY: 'scroll',
            position: 'absolute',
            top: listings.length >= 3 ? -250 : -175,
            zIndex: 250,
          }}
        >
          <MarkerOverlayContent overlayListings={listings} />
        </div>
      )}
      <div
        style={{
          position: 'absolute',
          zIndex: markerIndex,
          ...styles.markerIconStyle,
        }}
        onMouseOver={() => onMouseOverMarker(listing)}
        onMouseLeave={() => onMouseLeaveMarker()}
        onClick={() => onMarkerClick(listing)}
      >
        {listing.status === ListingStatus.New && (
          <div
            style={{
              position: 'relative',
              zIndex: markerIndex - 1,
              ...styles.newMarkerStyle,
            }}
          >
            <NewMarkerIcon />
          </div>
        )}
        <div
          style={{
            position: 'relative',
            zIndex: markerIndex + 1,
          }}
        >
          {marker}
        </div>
      </div>
    </div>
  );
};

export default ClusterMarker;
